import styled from '@emotion/styled'

export const StyleBannerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
`

export const StyleBannerCurrentBalanceWrapper = styled.div`
  width: 38%;
  background: ${(props: any) => props.theme.colors.secondary150};
  border-radius: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img {
    width: 55%;
    height: 100%;
  }
`

export const StyleBannerOtherInfoWrapper = styled.div`
  width: 30%;
  display: flex;
  flex-direction: column;
  row-gap: 10px;
`

export const StyleUserInfoCard = styled.div`
  border: 1px solid ${(props: any) => props.theme.colors.inputBorder};
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  column-gap: 10px;
  align-items: center;
  img {
    height: 60px;
    width: 60px;
    border-radius: 50%;
  }
`

export const StyleBankInfoCard = styled.div`
  background: ${(props: any) => props.theme.colors.yellow250};
  padding: 10px 15px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  row-gap: 5px;
`
